<template>
  <div class="OATimeline">
    <ul v-if="!empty">
      <li class="item" v-for="(item,index) in data" :key="index">
        <i class="el-icon-time"></i>
        <div class="wrapper">
          <div class="tail"></div>
          <div class="title">{{item.title}}{{item.status}}</div>
          <!-- <div class="content">
            <div v-for="(mo,index) in item.voList" :key="index">{{item.label}}{{mo.clockTime}}</div>
          </div>-->
        </div>
      </li>
    </ul>
    <div v-if="empty" class="empty">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: "OATimeline",
  props: {
    timedata: {
      default: []
    },
    props: {
      default: null
    }
  },
  watch: {
    timedata: {
      handler: function(val) {
        if (val && val.toworkStatus && val.offdutyStatus) {
          this.data[0].status = val.toworkStatus;
          this.data[1].status = val.offdutyStatus;
          // if (val.voList.length > 0) {
          //   let date = _.groupBy(val.voList, "distinguishBetween");
          //   this.data[0].voList = date["上班时间"];
          //   this.data[1].voList = date["下班时间"];
          // }
          this.empty = false;
        } else {
          this.empty = true;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      data: [
        {
          status: "",
          title: "上午考勤状态：",
          label: "上午打卡记录：",
          voList: []
        },
        {
          status: "",
          title: "下午考勤状态：",
          label: "下午打卡记录：",
          voList: []
        }
      ],
      empty: true
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss">
.OATimeline {
  background: #fff;
  color: #666;
  font-size: 16px;
  padding: 20px;
  .item {
    position: relative;
    .wrapper {
      position: relative;
      padding-left: 28px;
      top: -26px;
      left: 10px;
      .tail {
        position: absolute;
        left: 4px;
        top: 26px;
        height: 100%;
        border-left: 2px solid #ddd;
      }
    }
    &:last-child {
      .wrapper {
        .tail {
          border-left: none;
        }
      }
    }
  }
  .el-icon-time {
    font-size: 20px;
    margin: 5px;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/OATimeline/OATimeline.vue